// AuthInput — dark themed input with label + error slot.
export default function AuthInput({ label, error, testid, ...rest }) {
  return (
    <label className="block mb-4">
      {label && (
        <span className="block text-xs mb-1.5 font-medium"
              style={{ color: "#c9c9c9", letterSpacing: "0.3px" }}>{label}</span>
      )}
      <input
        {...rest}
        data-testid={testid}
        className="w-full px-3 py-2.5 text-sm rounded-md outline-none transition-colors"
        style={{
          background: "#0f0f0f",
          border: `1px solid ${error ? "#c86a6a" : "#333"}`,
          color: "#f7f7f7",
        }}
        onFocus={(e) => { e.target.style.borderColor = "#C9A86A"; }}
        onBlur={(e) => { e.target.style.borderColor = error ? "#c86a6a" : "#333"; }}
      />
      {error && (
        <span className="block text-xs mt-1.5" style={{ color: "#c86a6a" }}
              data-testid={testid ? `${testid}-error` : undefined}>{error}</span>
      )}
    </label>
  );
}
